import { render, staticRenderFns } from "./addselfgroup.vue?vue&type=template&id=1fdc5546&scoped=true"
import script from "./addselfgroup.vue?vue&type=script&lang=js"
export * from "./addselfgroup.vue?vue&type=script&lang=js"
import style0 from "./addselfgroup.vue?vue&type=style&index=0&id=1fdc5546&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1fdc5546",
  null
  
)

export default component.exports